export const GET_LIST_REQUEST = "History/GET_LIST_REQUEST";
export const GET_LIST_SUCCESS = "History/GET_LIST_SUCCESS";
export const GET_LIST_FAILURE = "History/GET_LIST_FAILURE";